import { Box, Typography } from "@mui/material";
import { C } from "../../theme/dashboardCardTokens";

// Same icon + title layout as the admin dashboard's top bar
// (pages/admin/Dashboard.js), reused here so the patient/therapist
// dashboards open with the same dashboard icon used in the sidebar.
function PortalPageHeader({ title, subtitle }) {
  return (
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: "10px", mb: 3 }}>
      <Box
        component="span"
        aria-hidden
        sx={{
          width: 22,
          height: 22,
          display: "inline-block",
          flexShrink: 0,
          mt: "1px",
          backgroundColor: "#000000",
          mask: "url(/icons/ic_dashboard.svg) center / contain no-repeat",
          WebkitMask: "url(/icons/ic_dashboard.svg) center / contain no-repeat",
        }}
      />
      <Box>
        <Typography sx={{ fontSize: 23, fontWeight: 800, color: C.ink, letterSpacing: "-0.02em", lineHeight: 1.15 }}>
          {title}
        </Typography>
        {subtitle && <Typography sx={{ fontSize: 13, color: C.textSecondary, mt: "2px" }}>{subtitle}</Typography>}
      </Box>
    </Box>
  );
}

export default PortalPageHeader;
